import { NavLink, Outlet } from "react-router-dom";
import { cn } from "@/lib/utils";

const tabs = [
  { label: "Members", path: "members" },
  { label: "Organization", path: "organization" },
  { label: "Integrations", path: "integrations" },
  { label: "API Tokens", path: "api-tokens" },
  { label: "Billing", path: "billing" },
];

export function SettingsLayout() {
  const base = "/settings";

  return (
    <div>
      <nav className="flex gap-1 border-b mb-6" aria-label="Settings">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={`${base}/${tab.path}`}
            className={({ isActive }) =>
              cn(
                "px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors",
                isActive
                  ? "border-primary text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground",
              )
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
